<template>
  <div class="DependentAndNotEmail" :class="{ 'ac-bg-black': ac }">
    <header-component
      :is-soon="false"
      img-left=""
      img-right="/trocachip/img/access.png"
      class="header-component"
      :backRoute="false"
    />
    <div class="change_chip_container">
      <img src="img/icons/notifications-alert-triangle-red.svg" id="icon_error" />
      <span
        class="DependentAndNotEmail_title"
        id="title_modal"
        :class="{ 'ac-color-white': ac }"
        v-html="DependentAndNotEmailPage.title"
      ></span>
      <div class="DependentAndNotEmail_subtitle" id="subtitle_modal">
        <span v-html="DependentAndNotEmailPage.subtitleEmailStatus"></span>
      </div>
    </div>

    <footer class="DependentAndNotEmail_container-button">
      <button
        class="DependentAndNotEmail_button"
        @click="nextFlow(DependentAndNotEmailPage.Button.flow)"
        :class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
      >
        {{ DependentAndNotEmailPage.Button.text }}
      </button>
    </footer>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import { mapState } from "vuex";

export default {
  name: "dependentAndNotEmail",
  components: {
    HeaderComponent,
  },
  created() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  },
  computed: mapState({
    ac: (state) => state.ac,
    document: (state) => state.document,
    config: (state) => state.config,
    customer: (state) => state.customer,
    initFlow: (state) => state.config["init_flow"],
    DependentAndNotEmailPage: (state) =>
      state.config.dependentAndNotEmailPage || {},
  }),
  methods: {
    nextFlow() {
      this.$router.push({ name: "welcome" });
    },
  },
};
</script>

<style lang="scss">
.DependentAndNotEmail {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  .change_chip_container {
    width: 90%;
    height: auto;
    margin: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
    > img {
      margin-top: 96px;
    }
  }
  .change_chip_email {
    width: 90%;
    height: auto;
    margin: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
  }
  .DependentAndNotEmail_title {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-block-end: 0 !important;
    margin-top: 24px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    text-align: center;
    color: #000000;
  }
  .DependentAndNotEmail_container-button {
    width: 100%;
    height: auto;
    margin-top: 28px;
    position: fixed;
    bottom: 0;
    justify-content: center;
    display: grid;
    align-items: center;
  }
  .DependentAndNotEmail_button {
    width: 286px;
    height: 52px;
    margin: 0 auto 24px auto;
    border-radius: 26px;
    border: solid 2px #003091;
    background: #003091;
    outline: none;
    font-size: 1em;
    text-align: center;
    color: #FFFFFF;
  }
  .DependentAndNotEmail_subtitle {
    width: 309px;
    min-height: 48px;
    margin: 16px auto 23px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
}
</style>
